export const breakpoints = {
  sm: `420px`,
  md: `768px`,
  lg: `1024px`,
  xl: `1440px`,
  '2xl': `2560px`
};
